import { useCallback, useRef } from 'react';
export function useFormEventDispatch(callbacks) {
  const callbacksRef = useRef(callbacks);
  callbacksRef.current = callbacks;
  return useCallback(eventName => {
    var _cbs$onFormEvent, _cbs$eventName;
    const cbs = callbacksRef.current;
    (_cbs$onFormEvent = cbs.onFormEvent) === null || _cbs$onFormEvent === void 0 || _cbs$onFormEvent.call(cbs, eventName);
    (_cbs$eventName = cbs[eventName]) === null || _cbs$eventName === void 0 || _cbs$eventName.call(cbs);
  }, []);
}